import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tags-chips',
  templateUrl: './tags-chips.component.html',
  styleUrls: ['./tags-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagsChipsComponent {
  private _value = '';

  /** Comma-separated tags: "Safety, PPS, RadMonitors" */
  @Input() set value(v: string | null | undefined) {
    this._value = v ?? '';
    this.tags = this.parseTags(this._value);
  }
  get value(): string { return this._value; }

  /** If true => cannot remove chips */
  @Input() disabled? = false;

  /** Optional: customize delimiter(s) */
  @Input() separators: RegExp = /,/;

  /** Optional: unique tags */
  @Input() unique = true;

  /** Emits the updated comma-separated value after removals */
  @Output() valueChange = new EventEmitter<string>();

  tags: string[] = [];

  remove(tag: string): void {
    if (this.disabled) return;

    this.tags = this.tags.filter(t => t !== tag);
    const next = this.tags.join(', ');
    this._value = next;
    this.valueChange.emit(next);
  }

  private parseTags(raw: string): string[] {
    if (!raw?.trim()) return [];

    const parts = raw
      .split(this.separators)
      .map(t => t.trim())
      .filter(t => t.length > 0);

    if (!this.unique) return parts;

    // unique while preserving order (case-insensitive)
    const seen = new Set<string>();
    const out: string[] = [];
    for (const p of parts) {
      const key = p.toLowerCase();
      if (!seen.has(key)) {
        seen.add(key);
        out.push(p);
      }
    }
    return out;
  }
}
